export default "__VITE_ASSET__CHOIPol7__"